<template>

  <div id="projHeader" class="projheader grid grid__item_span-12 p0 m0">
    <!-- <img :src="page.headerImageURL" :alt="page.headerImageTxt" :title="page.headerImageTxt" /> -->
    <div id="ultext" class="overlay">

      <a href="/services">
        <span id="image"><img src="../../../static/left-arrow.svg" alt="" title="" /></span>
      </a>

       <h4 class="txtWhite uppercase">{{page.serviceTitle}}</h4>
       <ul class="grid grid__item_span-10 p0 m0" v-for="item in page.contentAreas">
         <li v-for="(sec, index) in item.type" v-if="sec.acf_fc_layout === 'component_paragraph'"  v-on:click="scrollTo('sec-' + index)" class="grid grid__item_span-12 p0 m0">
          <span class="line"><div class="inner"></div></span>
          <span>{{sec.paragraph_sub_heading}}</span>
        </li>
       </ul>

    </div>
  </div>

</template>

<script>

import animateScrollTo from 'animated-scroll-to'

export default {
  name: 'Proj_header',
  props: [
    'page'
  ],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    scrollTo (destination) { // scroll to a div position
      setTimeout(function () {
        var destinationWrap = document.getElementById(destination)
        const options = {
          speed: 1900
        }
        animateScrollTo(destinationWrap, options)
      }, 200)
    }
  },
  mounted () {

  },
  components: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .singleImage {
    height: auto;
  }
  .singleImage img{
    width: 100%;
    height: 100%;
  }

  .image{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: cover;
  }


</style>



// WEBPACK FOOTER //
// src/components/project/serv_header.vue